import { render } from "./smallLoaderComponent.vue?vue&type=template&id=32307059&scoped=true"
import script from "./smallLoaderComponent.vue?vue&type=script&lang=js"
export * from "./smallLoaderComponent.vue?vue&type=script&lang=js"

import "./smallLoaderComponent.vue?vue&type=style&index=0&id=32307059&scoped=true&lang=css"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32307059"],['__file',"cartridges/int_guidedProductFinder/cartridge/client/default/js/components/smallLoaderComponent.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "32307059"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('32307059', __exports__)) {
    api.reload('32307059', __exports__)
  }
  
  module.hot.accept("./smallLoaderComponent.vue?vue&type=template&id=32307059&scoped=true", () => {
    api.rerender('32307059', render)
  })

}


export default __exports__